/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/',
    name: 'dashboard.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'dashboard/Index'
  },
  {
    path: '/dashboard',
    name: '',
    meta: { layout: 'private', requiresAuth: true },
    view: 'dashboard/Index'
  },
  {
    path: '/info/:id',
    name: 'info.title',
    meta: { layout: 'public', requiresAuth: false },
    view: 'statusRoom/Index'
  },
  {
    path: '/player-status',
    name: 'playerStatus.title',
    meta: { layout: 'public', requiresAuth: false },
    view: 'PlayerStatus'
  },
  {
    path: '/check-files',
    name: 'checkFiles.title',
    meta: { layout: 'public', requiresAuth: false },
    view: 'CheckFiles'
  },
  {
    path: '/test2',
    name: 'test.title',
    meta: { layout: 'public', requiresAuth: false },
    view: 'Test2'
  },
  {
    path: '/login',
    name: 'login.title',
    meta: { layout: 'public', requiresAuth: false },
    view: 'Login'
  },
  {
    path: '/users',
    name: 'users.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'users/Index'
  },
  {
    path: '/users/:id',
    name: 'users.userTitle',
    meta: { layout: 'private', requiresAuth: true },
    view: 'users/User'
  },
  {
    path: '/enterprises',
    name: 'enterprises.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'enterprises/Index'
  },
  {
    path: '/enterprises/:id',
    name: 'enterprises.enterpriseTitle',
    meta: { layout: 'private', requiresAuth: true },
    view: 'enterprises/Enterprise'
  },
  {
    path: '/status',
    name: 'status.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'dashboard/Index'
  },
  {
    path: '/players',
    name: 'playerSettings.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'playerSettings/Index'
  },
  {
    path: '/players/:id',
    name: 'playerSettings.enterpriseTitle',
    meta: { layout: 'private', requiresAuth: true },
    view: 'playerSettings/Player'
  },
  {
    path: '*',
    // Relative to /src/views
    meta: { layout: 'private', requiresAuth: true },
    view: '404'
  }
]
